import { RevokeIcon } from '#app/components/icons'

export default {
	name: 'Revoke',
	slug: 'revoke',
	description: 'Revoke an attestation you signed previously',
	version: '1.0.0',
	icon: <RevokeIcon />,
	isCountersign: true,
	fields: [
		{
			name: 'Description',
			slug: 'description',
			required: false,
			type: 'text',
			placeholder: 'Description of the revoke',
		},
		{
			name: 'Original Metadata CID',
			slug: 'originalMetadataIPFSCID',
			required: true,
			readOnly: true,
			hidden: true,
			type: 'text',
			placeholder: 'The IPFS CID of the original metadata',
		},
		{
			name: 'Original Attestation CID',
			slug: 'originalAttestationIPFSCID',
			required: true,
			readOnly: true,
			hidden: true,
			type: 'text',
			placeholder: 'The IPFS CID of the original attestation',
		},
	],
	info: 'https://atomicform.faq',
}
